
<template>
	<div id="results-page">
		<products-quicktable />
	</div>
</template>

<script>
	import ProductsQuicktable from "./ProductsQuicktable.vue";
	export default {
		name: "ProductsIndex",
		components: { ProductsQuicktable }
	};
</script>
